"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetEnquirySourceStatsApiResponseDto = instanceOfGetEnquirySourceStatsApiResponseDto;
exports.GetEnquirySourceStatsApiResponseDtoFromJSON = GetEnquirySourceStatsApiResponseDtoFromJSON;
exports.GetEnquirySourceStatsApiResponseDtoFromJSONTyped = GetEnquirySourceStatsApiResponseDtoFromJSONTyped;
exports.GetEnquirySourceStatsApiResponseDtoToJSON = GetEnquirySourceStatsApiResponseDtoToJSON;
exports.GetEnquirySourceStatsApiResponseDtoToJSONTyped = GetEnquirySourceStatsApiResponseDtoToJSONTyped;
var EnquirySourceStatItemDto_1 = require("./EnquirySourceStatItemDto");
/**
 * Check if a given object implements the GetEnquirySourceStatsApiResponseDto interface.
 */
function instanceOfGetEnquirySourceStatsApiResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function GetEnquirySourceStatsApiResponseDtoFromJSON(json) {
    return GetEnquirySourceStatsApiResponseDtoFromJSONTyped(json, false);
}
function GetEnquirySourceStatsApiResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(EnquirySourceStatItemDto_1.EnquirySourceStatItemDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function GetEnquirySourceStatsApiResponseDtoToJSON(json) {
    return GetEnquirySourceStatsApiResponseDtoToJSONTyped(json, false);
}
function GetEnquirySourceStatsApiResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(EnquirySourceStatItemDto_1.EnquirySourceStatItemDtoToJSON)),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
